<p-dialog
  header="Add Investor"
  [(visible)]="display"
  [style]="{ width: '560px' }"
  (onHide)="hideDialog()"
  [modal]="true"
>
  <form [formGroup]="addInvestorForm">
    <div class="form-grid">
      <div class="form-field">
        <label for="name">Name</label>
        <input
          pInputText
          id="name"
          type="text"
          formControlName="name"
          class="w-full"
          placeholder="Enter full name"
        />
        <small
          class="error-message"
          *ngIf="addInvestorForm.get('name')?.invalid && addInvestorForm.get('name')?.touched"
        >
          Name is required
        </small>
      </div>

      <div class="form-field">
        <label for="email">Email</label>
        <input
          pInputText
          id="email"
          type="email"
          formControlName="email"
          class="w-full"
          placeholder="Enter email address"
        />
        <small
          class="error-message"
          *ngIf="addInvestorForm.get('email')?.invalid && addInvestorForm.get('email')?.touched"
        >
          Enter a valid email address
        </small>
      </div>

      <div class="form-field">
        <label for="mobile_number">Phone Number</label>
        <input
          pInputText
          id="mobile_number"
          type="text"
          formControlName="mobile_number"
          class="w-full"
          placeholder="10-digit phone number"
        />
        <small
          class="error-message"
          *ngIf="addInvestorForm.get('mobile_number')?.invalid && addInvestorForm.get('mobile_number')?.touched"
        >
          Enter a valid 10-digit phone number
        </small>
      </div>

      <div class="form-field">
        <label for="pan">PAN</label>
        <input
          pInputText
          id="pan"
          type="text"
          formControlName="pan"
          class="w-full"
          placeholder="e.g. ABCDE1234F"
          style="text-transform: uppercase"
        />
        <small
          class="error-message"
          *ngIf="addInvestorForm.get('pan')?.invalid && addInvestorForm.get('pan')?.touched"
        >
          Enter a valid PAN (e.g. ABCDE1234F)
        </small>
      </div>

      <div class="form-field">
        <label for="dob">Date of Birth</label>
        <p-calendar
          id="dob"
          formControlName="dob"
          dateFormat="yy-mm-dd"
          [showIcon]="true"
          styleClass="w-full"
          placeholder="Select date of birth"
          appendTo="body"
        ></p-calendar>
        <small
          class="error-message"
          *ngIf="addInvestorForm.get('dob')?.invalid && addInvestorForm.get('dob')?.touched"
        >
          Date of Birth is required
        </small>
      </div>

      <div class="form-field">
        <label for="gender">Gender</label>
        <p-dropdown
          id="gender"
          formControlName="gender"
          [options]="[
            { label: 'Male', value: 'Male' },
            { label: 'Female', value: 'Female' },
            { label: 'Other', value: 'Other' }
          ]"
          placeholder="Select gender"
          optionLabel="label"
          optionValue="value"
          styleClass="w-full"
          appendTo="body"
        ></p-dropdown>
        <small
          class="error-message"
          *ngIf="addInvestorForm.get('gender')?.invalid && addInvestorForm.get('gender')?.touched"
        >
          Gender is required
        </small>
      </div>
    </div>
  </form>

  <small class="error-message" *ngIf="errorMessage">{{ errorMessage }}</small>

  <ng-template pTemplate="footer">
    <button
      pButton
      label="Cancel"
      class="p-button-secondary"
      type="button"
      (click)="hideDialog()"
      [disabled]="loading"
    ></button>
    <button
      pButton
      label="Add Investor"
      type="button"
      (click)="onSubmit()"
      [disabled]="addInvestorForm.invalid || loading"
      [loading]="loading"
    ></button>
  </ng-template>
</p-dialog>
